import { useEffect } from 'react';

declare global {
  interface Window {
    $crisp: unknown[];
    CRISP_WEBSITE_ID: string;
  }
}

interface CrispChatProps {
  websiteId: string;
}

export function CrispChat({ websiteId }: CrispChatProps) {
  useEffect(() => {
    if (!websiteId || window.$crisp) return;

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = websiteId;

    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup on unmount
      const el = document.getElementById('crisp-chatbox');
      if (el) el.remove();
      script.remove();
    };
  }, [websiteId]);

  return null;
}
